import { CkEditorListPropertiesDialogComponent } from './ck-editor-list-properties-dialog.component';
import { DialogService, IDialogHandle } from '../dialogs/dialog.service';
import { DialogCloseReason, IDialogOnClose } from '../dialogs/base-dialog';
import { ICkEditorCdListPropertiesPluginService, IListPropertiesModel } from './ck-editor-cd-list-properties-plugin.interface';

declare var CKEDITOR: any;
type ICommandDefinition = CKEDITOR.commandDefinition;
type CKEditor = CKEDITOR.editor;

export class CDListPropertiesCommand implements ICommandDefinition {
  constructor(private dialogService: DialogService,
              private plugin: ICkEditorCdListPropertiesPluginService) {
  }

  onOk(editor: CKEDITOR.editor, listProperties: IListPropertiesModel, listElement: any) {
    // clear the current style of the element and add the new styles as selected
    listElement.removeAttribute('style');

    listElement.style.color = listProperties.color ? listProperties.color : '';
    listElement.style.fontSize = listProperties.fontSize ? listProperties.fontSize : '';
    listElement.style.fontWeight = listProperties.isBold ? 'bold' : '';
    listElement.style.fontStyle = listProperties.isItalic ? 'italic' : '';

    if (!listProperties.isOrderedList) {
      if (listProperties.bulletType !== 'disc') {
        listElement.style.listStyleType = listProperties.bulletType;
      } else {
        listElement.style.listStyleType = '';
      }
    }

    if (listProperties.isOrderedList) {
      if (listProperties.orderedListType !== 'decimal') {
        listElement.style.listStyleType = listProperties.orderedListType;
      } else {
        listElement.style.listStyleType = '';
      }
    }

    if (listProperties.isOrderedList && listProperties.startFrom !== 1) {
      listElement.setAttribute('start', listProperties.startFrom);
    } else {
      listElement.removeAttribute('start');
    }

    // add the font manually to overcome spaces and the " char added by the browser in the font name. does not work in outlook.
    if (listProperties.fontFamily) {
      let styleAttributeContent = listElement.getAttribute('style');
      let styleAttributeToAddFontTo = styleAttributeContent ? styleAttributeContent : '';
      styleAttributeToAddFontTo += ` font-family:${listProperties.fontFamily}; `;
      listElement.setAttribute('style', styleAttributeToAddFontTo);
    }
  }

  exec(editor: CKEditor, data?: Object): boolean {
    editor.focusManager.lock();

    let selection: any = editor.getSelection();
    let rangeOfSelectionBeforeDialog: CKEDITOR.dom.range = selection.getRanges()[0];

    this.plugin.zone.run(() => {

      let dialogHandle: IDialogHandle = this.dialogService.createDialog(CkEditorListPropertiesDialogComponent, {
        listProperties: this.plugin.currentListProperties,
        colorsPersistenceKey: this.plugin.presetColorsPersistenceKey
      });

      dialogHandle.onClose.subscribe((result: IDialogOnClose) => {
        if (result.reason === DialogCloseReason.OK) {
          let listProperties: IListPropertiesModel = <IListPropertiesModel> result.data;
          this.onOk(editor, listProperties, this.plugin.listElement);
        }
        else {
          rangeOfSelectionBeforeDialog.select();
        }

        editor.focusManager.unlock();
        editor.focus();
      });

    });
    //indicate the the command was executed successfully
    return true;
  }
}

